module.exports = __webpack_public_path__ + "static/media/code2040.b3bd26bc.jpeg";